export const formMasterApi = {
    getForms: 'v1/api/formsMaster',
    createformsMaster: 'v1/api/formsMaster',
    editOptions: 'v1/api/formsMaster',
    extractStudentInterviewData: 'v1/api/interviewList/export',
    deteleOptions: 'v1/api/options',
    getOptionById: 'v1/api/formsMaster/getById?id=',
    getOptionCouserType: 'v1/api/options?type=Course Type',
    getOptionsForUniversityDocumentType:
        'v1/api/options?type=University Document Type',
    getOptionsForApplicationType: 'v1/api/options?type=Application Type',
    getOptionsForIntake: 'v1/api/options?type=Intake',
    getOptionsForMarksheetType: 'v1/api/options?type=Marksheet Type',
    getOptionsForMarksheetSection: 'v1/api/options?type=Marksheet Section',
    getOptionsForPreviousAcadmicCourse:
        'v1/api/options?type=Previous Academic Course',
    getOptionsForCampus: 'v1/api/options?type=Campus',
    getFormByID: 'v1/api/formsMaster/getById?id=',
    getUniversityID: 'v1/api/formsMaster/getById?universityId=',
    saveForm: 'v1/api/applicationForms',
    //get application form using ID
    //getApplicationForms: 'v1/api/interviewList/getById?id=',
    getApplicationForms: 'v1/api/applicationForms?applicationId=',
    getInterviewFormById: 'v1/api/interviewList/getById?id=',
    generatePdf: 'v1/api/interviewList/generate-pdf',
    getInterViewStatus: 'v1/api/options?type=interviewStatus',
    saveInterViewPassportImage: 'v1/api/applicationForms/uploadImage',
    getByIdInterviewDetails: 'v1/api/application/getByIdInterviewDetails',
    getdmuOfferletter: 'Agent_nomination_form/dmu_paper_application.php?orderid=',
    getshuOfferletter:'Agent_nomination_form/shu_paper_applicationUG.php?orderid=',
    getGreenWhich:'fpdm_greenwitch_feedback/greenwich-interview.php',
    getgcdOfferletter:'Agent_nomination_form/gcd_papper_application.php?orderid=',
    qualityCheckDetails:'v1/api/qualityCheck',
    qualityCheckMail:'v1/api/userMailMaster/incoming-email',
    getlbuAgentForm:'Agent_nomination_form/lbu.php?orderid=',
    interviewllm: 'v1/api/interviewllm',
    getinterviewllmById: 'v1/api/interviewllm/getById?id=',
    getAiInterviewLogs: 'v1/api/interviewAi',
    syncAiInterview: 'v1/api/interviewAi/syncInterview',
    downloadProc: 'v1/api/interviewAi/downloadProctoringReport',
    getManchesterForm:'Agent_nomination_form/manchester.php?orderid=',
    veriffWebhookReport: 'v1/api/interviewAi/downloadVeriffReport',
    syncGoogleMeetVideo: 'v1/api/interviewList/track-upload'
};